const EARLIEST_YEAR = 2023;

function generateYearOptions() {
    const maxYear = new Date().getFullYear();
    const years = [];
    for (let y = maxYear; y >= EARLIEST_YEAR; y--) {
        years.push({ label: String(y), value: y });
    }
    return years;
}

const YEAR_OPTIONS = generateYearOptions();

export default YEAR_OPTIONS;
